<template>
  <div>
    <div class="subheader py-3 py-lg-3 subheader-transparent transparent">
      <div
        class="
          d-flex
          align-items-center
          justify-content-between
          flex-wrap flex-sm-nowrap
          container-fluid
          p-0
        "
      >
        <div class="d-flex align-items-baseline mr-5 mb-5">
          <h3 class="subheader-title text-dark font-weight-bold my-2 mr-3">
            Data Analytics Report
          </h3>
        </div>
        <div class="d-flex align-items-center">...</div>
      </div>
    </div>

    <div class="card card-custom gutter-b card-stretch">
      <!--begin::Header-->
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label font-weight-bolder text-dark">
            Realtime cumulative data for
            <span class="text-primary">{{ getYesterday() }}</span>
            and
            <span class="text-primary">
              {{ getToday() }}
            </span>
          </span>
        </h3>
        <div class="card-toolbar">
          <JsonCSV
            v-if="mergeData()"
            :data="mergeData()"
            class="btn btn-sm btn-danger font-weight-bold"
          >
            Download
          </JsonCSV>
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body py-0 pb-10">
        <b-table
          responsive
          striped
          hover
          :items="previewData()"
          :busy.sync="isBusy"
          class="mt-3"
          outlined
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle" />
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
      </div>
      <!--end::Body-->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import JsonCSV from 'vue-json-csv'
import { yesterday, today } from '@/core/helpers/temp/util.js'

export default {
  name: 'data_analytics',
  components: {
    JsonCSV,
  },
  data() {
    return {
      upToYesterdayData: null,
      upToTodaysData: null,
      isBusy: false,
    }
  },
  async mounted() {
    await this.fetchData()
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    fetchData() {
      this.isBusy = true
      const apiUrl = process.env.VUE_APP_SERVICE_URL

      // get report - up to today
      axios
        .get(`${apiUrl}/api/cluster_immunization/fetch_reports`, {
          params: {
            report: 'v_report_cumulative_upto_today',
          },
        })
        .then((res) => {
          // console.log(res)
          this.upToTodaysData = Object.freeze(res.data.items)
        })
        .catch((err) => {
          console.log(err)
        })

      // get report - up to yesterday
      axios
        .get(`${apiUrl}/api/cluster_immunization/fetch_reports`, {
          params: {
            report: 'v_report_cumulative_upto_yesterday',
          },
        })
        .then((res) => {
          console.log(res)
          this.upToYesterdayData = Object.freeze(res.data.items)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    mergeData() {
      if (this.upToYesterdayData && this.upToTodaysData) {
        return [...this.upToYesterdayData, ...this.upToTodaysData]
      }
    },
    previewData() {
      if (this.upToTodaysData) {
        this.isBusy = false
        return this.upToTodaysData.slice(0, 10)
      }
    },
    getToday() {
      return today()
    },
    getYesterday() {
      return yesterday()
    },
  },
}
</script>

<style lang="scss" scoped></style>
